export const ACTION_TYPES = {
    PROCEED_WITHOUT_COUPON: "PROCEED_WITHOUT_COUPON",
    DISMISS: "DISMISS",
};

export const DISPLAY_NAMES = {
    PROCEED_WITHOUT_COUPON: "PROCEED WITHOUT COUPON",
    DISMISS: "DISMISS",
};

export const TEXTS = {
    title: "Transaction Failed",
    icon: "payment_failure_icon_gzp8qe",
    actionTypes: [
        {
            displayName: DISPLAY_NAMES.DISMISS,
            actionType: ACTION_TYPES.DISMISS,
        },
        {
            displayName: DISPLAY_NAMES.PROCEED_WITHOUT_COUPON,
            actionType: ACTION_TYPES.PROCEED_WITHOUT_COUPON,
        },
    ],
};
